<template>
  <div class="py-1">
    <v-row>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-text-field
              name="start_date"
              :value="form.start_date | dateFormat"
              :label="$t('PLANNINGS.START_DATE')"
              :error-messages="errors.start_date"
              prepend-inner-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-checkbox
              v-model="form.auto_renew"
              name="auto_renew"
              :label="$t('PLANNINGS.TASKS.EVENT.AUTO_RENEW')"
              :readonly="readonly"
              :error="errors.auto_renew"
              @change="updateValue('auto_renew', $event)"
            ></v-checkbox>
          </v-col>
          <v-col v-if="!form.auto_renew" cols="12">
            <v-text-field
              v-if="readonly"
              name="end_date"
              :value="form.end_date | dateFormat"
              :label="$t('PLANNINGS.END_DATE')"
              :error-messages="errors.end_date"
              prepend-inner-icon="mdi-calendar"
              readonly
            ></v-text-field>

            <v-menu
              v-else
              ref="menuEndDate"
              min-width="290px"
              transition="scale-transition"
              :close-on-content-click="false"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  autocomplete="nope"
                  prepend-inner-icon="mdi-calendar"
                  :value="form.end_date | dateFormat"
                  :label="$t('PLANNINGS.END_DATE')"
                  :readonly="readonly"
                  :error-messages="errors.end_date"
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="form.end_date = null"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.end_date"
                :min="form.start_date"
                :max="maxEndDate"
                first-day-of-week="1"
                @change="setEndDate"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="form.reiteration"
              outlined
              name="reiteration"
              item-value="id"
              item-text="name"
              :items="reiterationsList"
              :label="$t('PLANNINGS.REPEAT')"
              :error-messages="errors.reiteration"
              :readonly="readonly"
              @change="updateValue('reiteration', $event)"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <weekdays
              v-model="form.days"
              color="primary"
              :error-messages="errors.days"
              :readonly="readonly"
              @input="updateValue('days', $event)"
            ></weekdays>
          </v-col>
          <v-col v-if="readonly" cols="12" class="d-flex justify-end">
            <v-btn
              color="error"
              :disabled="disableDelete"
              depressed
              @click="remove"
            >
              {{ $t('BUTTON.DELETE') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import Weekdays from '@/modules/_global/_components/Weekdays';
import formEditable from '@/modules/_global/mixins/form-editable';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'EventMultiTasksForm',

  filters: {
    dateFormat
  },

  components: {
    Weekdays
  },

  mixins: [formEditable, i18nRefreshData],

  props: {
    disableDelete: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        reiteration: 0,
        start_date: '',
        auto_renew: true,
        end_date: '',
        days: []
      }
    };
  },

  computed: {
    ...mapState('planning', ['currentTask', 'reiterationsList']),

    maxEndDate() {
      return moment(this.form.start_date || undefined)
        .add(3, 'month')
        .format(moment.HTML5_FMT.DATE);
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapCacheActions('planning', ['getReiterationsList']),

    refreshData() {
      this.getReiterationsList();
    },

    setEndDate(date) {
      this.$refs.menuEndDate.save(date);
      this.updateValue('end_date', date);
    },

    remove() {
      this.$emit('remove');
    }
  }
};
</script>

<style scoped></style>
